(function() {
  const STORAGE_KEY = 'olenaWishlist';
  let wishlist = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];

  const save = () => localStorage.setItem(STORAGE_KEY, JSON.stringify(wishlist));

  const updateCounter = () => {
    document.querySelectorAll('.wishlist-count').forEach(el => {
      el.textContent = wishlist.length;
    });
  };

  const attachBtn = (btn) => {
    if (btn.dataset.wishlistAttached) return;
    btn.dataset.wishlistAttached = '1';
    const id = btn.dataset.wishlistId;
    if (!id) return;
    btn.innerHTML = wishlist.includes(id) ? '♥' : '♡';
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (wishlist.includes(id)) {
        wishlist = wishlist.filter(i => i !== id);
        btn.innerHTML = '♡';
      } else {
        wishlist.push(id);
        btn.innerHTML = '♥';
      }
      save();
      updateCounter();
    });
  };

  const attachAll = () => {
    document.querySelectorAll('.wishlist-btn, .wishlist-card-btn').forEach(attachBtn);
  };

  // Observer pour AJAX / infinite scroll
  const observer = new MutationObserver(() => attachAll());
  observer.observe(document.body, { childList: true, subtree: true });

  document.addEventListener('DOMContentLoaded', () => {
    updateCounter();
    attachAll();
  });
})();

